<template>
  <commonSelect
    :value="value"
    @input="v=>$emit('input',v)"
    :placeholder="placeholder"
    :clearable="clearable"
    idKey="DpId"
    labelKey="DpName"
    :get-data-func="getDataFunc"
  />
</template>
<script>
import commonSelect from "@/components/common/select";
export default {
  props: {
    value: {},
    clearable: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: "请选择分管部门",
    },
  },
  components: { commonSelect },
  data() {
    return {
      api: require("@/api/ent/dp").default,
    };
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        this.api.list({  }).then((res) => {
          resolve(res);
        });
      });
    },
  },
};
</script>

